export enum DrugDetailControlCodes {
  ARTICLES = 'level3_article',
  SIDE_EFFECT = 'level3_possible_side_effect',
  HEADER_DRUG = 'level3_header_drug',
  HEADER_TOPICS = 'level3_header_topic',
  OVERVIEW = 'level3_overview_drug',
  TAGS = 'level3_tags',
  RELATED_TOPICS = 'level3_related_topics'
}
